<template>
  <div class="printlink">
    <a v-if="!downloading" :disabled="generated" @click="triggerReport">
      <slot></slot>
    </a>

    <span class="fa-light fa-spinner" v-if="downloading"></span>
  </div>
</template>

<script>
import axios from 'axios';
import debounce from '../debounce';

export default {
  name: 'printlink',
  props: ['eventOnPrint', 'href', 'params', 'modal_id', 'use_print_service', 'use_post_method'],
  data: function () {
    const baseUrl = `${window.config.ePersonamService.ePersonamHost}`;

    return {
      activity_button: false,
      activity_report: false,
      hospice_domicliare: false,
      birthday: false,
      downloading: false,
      generated: false,
      orientation: 'landscape',
      radio_button: false,
      course_button: false,
      event_selection: false,
      consumo_farmaci: false,
      consumo_farmaci_previsto: false,
      remove_from_to: false,
      month_year_filter: false,
      guest_and_drug_select: false,
      measurement_type: 0,
      ldp: false,
      desease_radio_button: false,
      medication_select: false,
      select_guest: false,
      select_vmd: false,
      is_icf: false,
      is_need: false,
      show_from: false,
      from: null,
      to: null,
      warning: null,
      report_type: 'pdf',
      baseUrl,
    };
  },
  created() {
    this.report_type = this.params.report_type || 'pdf';
    this.activity_button = this.params.activity_button || false;
    this.hospice_domicliare = this.params.hospice_domicliare || false;
    this.activity_report = this.params.activity_report || false;
    // eslint-disable-next-line vue/no-mutating-props
    delete this.params.activity_button;
    this.orientation = this.params.orientation || 'landscape';
    this.radio_button = this.params.radio_button || false;
    // eslint-disable-next-line vue/no-mutating-props
    delete this.params.radio_button;
    this.course_button = this.params.course_button || false;
    // eslint-disable-next-line vue/no-mutating-props
    delete this.params.course_button;
    this.event_selection = this.params.event_selection || false;
    // eslint-disable-next-line vue/no-mutating-props
    delete this.params.event_selection;
    this.consumo_farmaci = this.params.consumo_farmaci || false;
    // eslint-disable-next-line vue/no-mutating-props
    delete this.params.consumo_farmaci;
    this.consumo_farmaci_previsto = this.params.consumo_farmaci_previsto || false;
    // eslint-disable-next-line vue/no-mutating-props
    delete this.params.consumo_farmaci_previsto;
    this.guest_and_drug_select = this.params.guest_and_drug_select || false;
    // eslint-disable-next-line vue/no-mutating-props
    delete this.params.guest_and_drug_select;
    this.ldp = this.params.ldp || false;
    // eslint-disable-next-line vue/no-mutating-props
    delete this.params.ldp;
    this.desease_radio_button = this.params.desease_radio_button || false;
    // eslint-disable-next-line vue/no-mutating-props
    delete this.params.desease_radio_button;
    this.medication_select = this.params.medication_select || false;
    // eslint-disable-next-line vue/no-mutating-props
    delete this.params.medication_select;
    this.select_guest = this.params.select_guest || false;
    // eslint-disable-next-line vue/no-mutating-props
    delete this.params.select_guest;
    this.select_vmd = this.params.select_vmd || false;
    // eslint-disable-next-line vue/no-mutating-props
    delete this.params.select_vmd;
    this.is_icf = this.params.is_icf || false;
    // eslint-disable-next-line vue/no-mutating-props
    delete this.params.is_icf;
    this.is_need = this.params.is_need || false;
    // eslint-disable-next-line vue/no-mutating-props
    delete this.params.is_need;
    this.show_from = this.params.show_from || false;
    // eslint-disable-next-line vue/no-mutating-props
    delete this.params.show_from;
    this.birthday = this.params.birthday || false;
    // eslint-disable-next-line vue/no-mutating-props
    delete this.params.birthday;
    this.measurement_type = this.params.measurement_type || 0;
    this.remove_from_to = this.params.remove_from_to || false;
    this.month_year_filter = this.params.month_year_filter || false;
  },
  mounted() {
    eventBus.$on('reportRangeChange', (fromToSet) => {
      this.from = fromToSet.from;
      this.to = fromToSet.to;
      this.warning = fromToSet.warning;
    });
  },
  computed: {
    parameters() {
      return JSON.parse(
        JSON.stringify({ ...this.params, from: this.from, to: this.to, warning: this.warning, use_print_service: this.use_print_service }),
      );
    },
  },
  methods: {
    generateReport() {
      if (window.config.notificationService.enableNotifications) {
        this.downloading = true;
        axios
          .get(this.href, {
            responseType: 'json',
            params: this.parameters,
          })
          .then((res) => {
            if (typeof res.data === 'string') {
              throw new Error('Received unexpected string response');
            }
            eventBus.$emit('generateReport', res.data);
            this.downloading = false;
            this.generated = true;
          })
          .catch((error) => {
            this.downloading = false;
            this.generated = false;
          });
      } else {
        $('<a>')
          .attr('href', `/it/reports/generate_report.html?${jQuery.param(this.parameters)}`)
          .attr('target', '_blank')[0]
          .click();
      }
    },
    async generateReportByPost() {
      if (window.config.notificationService.enableNotifications) {
        this.downloading = true;

        try {
          const { current_units, ...restParameters } = this.parameters;

          const data = await this.adv_common.apiConnector('POST').fetch(`${this.baseUrl + this.href}`, {
            params: restParameters,
            method: 'POST',
            body: JSON.stringify({ current_units }),
            headers: { 'Content-Type': 'application/json' },
          });

          eventBus.$emit('generateReport', data);
          this.downloading = false;
          this.generated = true;
        } catch (e) {
          console.error(e);
          this.downloading = false;
          this.generated = false;
        }
      } else {
        $('<a>')
          .attr('href', `/it/reports/generate_report.html?${jQuery.param(this.parameters)}`)
          .attr('target', '_blank')[0]
          .click();
      }
    },
    openModal() {
      if (this.activity_report) {
        eventBus.$emit('generateReportGuestActivityMat', { worker: this.params.worker, type: this.report_type });
        return;
      }
      $(this.modal_id + ' form input#worker[type=hidden]').val(this.params.worker);
      $(this.modal_id + ' form input#orientation[type=hidden]').val(this.orientation);
      const hospice_domicliare = $(this.modal_id + ' form .hospice_domicliare');
      hospice_domicliare.val(this.hospice_domicliare);
      const activity_button = $(this.modal_id + ' form .activity_select');
      activity_button.toggle(this.activity_button);
      const div_radio_button = $(this.modal_id + ' form .radio_button_report');
      div_radio_button.toggle(this.radio_button);
      const course_button = $(this.modal_id + ' form .course_select');
      course_button.toggle(this.course_button);
      const event_selection = $(this.modal_id + ' form .event_selection');
      event_selection.toggle(this.event_selection);
      const consumo_farmaci = $(this.modal_id + ' form .consumo_farmaci');
      consumo_farmaci.toggle(this.consumo_farmaci);
      const consumo_farmaci_previsto = $(this.modal_id + ' form .consumo_farmaci_previsto');
      consumo_farmaci_previsto.toggle(this.consumo_farmaci_previsto);
      const guest_and_drug_select = $(this.modal_id + ' form .guest_and_drug_select');
      guest_and_drug_select.toggle(this.guest_and_drug_select);
      const measurement_type = $('form .measurement_selection');
      measurement_type.toggle(this.measurement_type != 0);
      const activity_exam_select = $(this.modal_id + ' form .activity_exam_select');
      activity_exam_select.toggle(this.measurement_type != 0 || this.activity_button);
      const ldp = $(this.modal_id + ' form .ldp');
      ldp.toggle(this.ldp);
      const desease_radio_button = $(this.modal_id + ' form .desease_radio_button');
      desease_radio_button.toggle(this.desease_radio_button);
      const medication_select = $(this.modal_id + ' form .medication_select');
      medication_select.toggle(this.medication_select);
      const select_guest = $(this.modal_id + ' form .select_guest');
      select_guest.toggle(this.select_guest);
      const select_vmd = $(this.modal_id + ' form .select_vmd');
      select_vmd.toggle(this.select_vmd);
      const is_icf = $(this.modal_id + ' form #is_icf');
      is_icf.val(this.is_icf);
      const is_need = $(this.modal_id + ' form #is_need');
      is_need.val(this.is_need);
      const show_from = $(this.modal_id + ' form .show-from');
      show_from.toggle(this.show_from);
      const birthday = $(this.modal_id + ' form .birthday');
      birthday.toggle(!this.birthday);
      const birthday_show = $(this.modal_id + ' form .birthday-show');
      birthday_show.toggle(this.birthday);
      const from_to = $(this.modal_id + ' form .from-to');
      from_to.toggle(!this.remove_from_to);
      const month_year_filter = $(this.modal_id + ' form .month-year-filter');
      month_year_filter.toggle(this.month_year_filter);
      const enable_month_year = $(this.modal_id + ' form .month-year-filter #enable_month_year');
      enable_month_year.val(this.month_year_filter);
      $('#row-from-data').toggle(this.params.worker != 'QuesturaTxtWorker');

      $(this.modal_id).modal('show');
    },
    triggerReport: debounce(function () {
      if (this.modal_id == undefined || this.modal_id == '') {
        if (this.use_post_method === true) {
          this.generateReportByPost();
        } else {
          this.generateReport();
        }
      } else if (this.modal_id == 'openGenericFiltersModal') {
        eventBus.$emit('openGenericFiltersModal', {
          filters: this.params.filters,
          params: { data: this.params.data, worker: this.params.worker, type: this.params.type },
        });
      } else {
        this.openModal();
      }
      if (this.eventOnPrint) {
        eventBus.$emit(this.eventOnPrint);
      }
    }, 300),
  },
};
</script>

<style lang="scss" scoped>
.printlink {
  cursor: pointer;
  display: inline-block;
}
</style>
